Backbone.Form = Backbone.Model.extend({
    constructor: function () {
        Backbone.Model.prototype.constructor.apply(this, arguments);
    },

    validateWithServer: function(options){
        var model = this;
        var success = options.success;
        var error = options.error;
        var attributes = this.attributes;
        options.success = function(resp) {
            model.attributes = attributes;
            if (success) success.call(options.context, model, resp, options);
        };
        options.error = function(resp) {
            if (error) error.call(options.context, model, resp, options);
        };

        return this.sync('create', this, options);
    },

    save: null,
    fetch: null,
    destroy: null
});


//////////////////
// WEBPACK FOOTER
// ./assets/common/common/js/libs/landfx/backbone.form.js
// module id = 9
// module chunks = 0